export default __webpack_public_path__ + "static/media/Coupon_icon.154e46ed.svg";